module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/operator-info.45432e86.svg";